import React from 'react'
import PropTypes from 'prop-types'

import ServiceCard from './ServiceCard'
import { Text } from 'components/base'
import HtmlIcon from './servicesIcons/html.svg'
import FilesIcon from './servicesIcons/text-md.svg'
import GoogleIcon from './servicesIcons/google.svg'
import DocxIcon from './servicesIcons/doc-docx.svg'
import ConfluenceIcon from './servicesIcons/confluence.svg'
import EvernoteIcon from './servicesIcons/evernote.svg'
import QuipIcon from './servicesIcons/quip.svg'

const confuenceServiceCardOptionFeatureFlag = {
  description: 'Import files from your account',
  onClickFactory: props => props.onConfluenceSelected,
}

const serviceCardOptionsList = [
  {
    name: 'Markdown or text',
    description: 'Import text or markdown files',
    onClickFactory: props => () => props.onManualImport('.md,.txt'),
    icon: FilesIcon,
  },
  {
    name: 'Html',
    description: 'Import html',
    onClickFactory: props => () => props.onManualImport('.html,.htm'),
    icon: HtmlIcon,
  },
  {
    name: 'Word documents',
    description: 'Import doc or docx',
    onClickFactory: props => () => props.onManualImport('.doc,.docx'),
    icon: DocxIcon,
  },
  {
    name: 'Quip',
    description: 'Follow our migration guide',
    onClickFactory: props => () =>
      props.onGuideSelected('quip', {
        uploadFormat: '.html,.md',
        creationSource: 'quip',
      }),
    icon: QuipIcon,
  },
  {
    name: 'Google Drive',
    description: 'Import files from your account',
    onClickFactory: props => props.onGoogleDriveImport,
    icon: GoogleIcon,
  },
  {
    name: 'Evernote',
    description: 'Follow our migration guide',
    onClickFactory: props => () =>
      props.onGuideSelected('evernote', {
        uploadFormat: '.html',
        creationSource: 'evernote',
      }),
    icon: EvernoteIcon,
  },
  {
    name: 'Confluence',
    description: 'Follow our migration guide',
    onClickFactory: props => () =>
      props.onGuideSelected('confluence', {
        uploadFormat: '.doc,.html,.htm',
        creationSource: 'confluence',
      }),
    icon: ConfluenceIcon,
  },
]

class ProviderContainer extends React.Component {
  static propTypes = {
    onGoogleDriveImport: PropTypes.func.isRequired,
    onManualImport: PropTypes.func.isRequired,
    onGuideSelected: PropTypes.func.isRequired,
  }

  static defaultProps = {}

  render() {
    return (
      <React.Fragment>
        <Text.Title className="margin-bottom-small">Source</Text.Title>
        <Text.Corpus className="margin-bottom-large">
          Select how you want to import your files
        </Text.Corpus>
        <section className="file-import-service-list flexbox margin-bottom-normal flexbox-wrap">
          {serviceCardOptionsList.map(serviceCardOptions => {
            if (serviceCardOptions.name === 'Confluence') {
              serviceCardOptions = {
                ...serviceCardOptions,
                ...(this.props.hasConfluenceImportFeatureFlag &&
                  confuenceServiceCardOptionFeatureFlag),
              }
            }
            return (
              <ServiceCard
                key={serviceCardOptions.name}
                icon={serviceCardOptions.icon}
                description={serviceCardOptions.description}
                onClick={serviceCardOptions.onClickFactory(this.props)}
                name={serviceCardOptions.name}
              />
            )
          })}
        </section>
      </React.Fragment>
    )
  }
}

export default ProviderContainer
